import { IntlShape } from 'react-intl';

export interface DuplicateApplicantDataType {
  modalContentText: string;
  cancelButtonText: string;
  applicantId?: string;
  duplicateMessage?: string;
}

export const canReapplyMessages = (
  intl: IntlShape,
): DuplicateApplicantDataType => {
  return {
    modalContentText: intl.formatMessage({
      defaultMessage:
        'We already have an application associated with the information you submitted. We can send you a link to continue with your previous application, or you can apply again as a new applicant.',
      description:
        'Description indicating next steps when applicant can reapply',
    }),
    cancelButtonText: intl.formatMessage({
      defaultMessage: 'No, apply again',
      description: 'Button to close the modal and apply again',
    }),
  };
};

export const getLinkMessages = (
  intl: IntlShape,
): DuplicateApplicantDataType => {
  return {
    modalContentText: intl.formatMessage({
      defaultMessage:
        'We already have an application associated with the information you submitted. This position only allows one application, but we can send you a link to continue your previous application.',
      description:
        'Description indicating next steps when applicant cannot reapply',
    }),
    cancelButtonText: intl.formatMessage({
      defaultMessage: 'Close',
      description: 'Button to close the modal',
    }),
  };
};

export const locales = Object.freeze([
  { code: 'en-GB', shortCode: 'UK', language: 'English-UK', flag: '🇬🇧' },
  { code: 'en-US', shortCode: 'US', language: 'English-US', flag: '🇺🇸' },
  { code: 'fr-FR', shortCode: 'FR', language: 'French', flag: '🇫🇷' },
  { code: 'it-IT', shortCode: 'IT', language: 'Italian', flag: '🇮🇹' },
  { code: 'es-ES', shortCode: 'ES', language: 'Spanish', flag: '🇪🇸' },
  { code: 'de-DE', shortCode: 'DE', language: 'German', flag: '🇩🇪' },
  { code: 'ar', shortCode: 'AR', language: 'Arabic', flag: '🇦🇪' },
  { code: 'bg-BG', shortCode: 'BG', language: 'Bulgarian', flag: '🇧🇬' },
  { code: 'zh-CN', shortCode: 'CN', language: 'Chinese-CN', flag: '🇨🇳' },
  { code: 'zh-TW', shortCode: 'TW', language: 'Chinese-TW', flag: '🇨🇳' },
  { code: 'cs-CZ', shortCode: 'CZ', language: 'Chinese', flag: '🇨🇿' },
  { code: 'nl-NL', shortCode: 'NL', language: 'Dutch', flag: '🇳🇱' },
  { code: 'fi-FI', shortCode: 'FI', language: 'Finnish', flag: '🇫🇮' },
  { code: 'el-GR', shortCode: 'GR', language: 'Greek', flag: '🇬🇷' },
  { code: 'he-IL', shortCode: 'IL', language: 'Hebrew', flag: '🇮🇱' },
  { code: 'hi-IN', shortCode: 'HI-IN', language: 'Hindi', flag: '🇮🇳' },
  { code: 'bn-IN', shortCode: 'BN-IN', language: 'Bengali', flag: '🇮🇳' },
  { code: 'gu-IN', shortCode: 'GU-IN', language: 'Gujarati', flag: '🇮🇳' },
  { code: 'pa-IN', shortCode: 'PA-IN', language: 'Punjabi', flag: '🇮🇳' },
  { code: 'id-ID', shortCode: 'ID', language: 'Indonesia', flag: '🇮🇩' },
  { code: 'ja-JP', shortCode: 'JP', language: 'Japanese', flag: '🇯🇵' },
  { code: 'kn-IN', shortCode: 'KN-IN', language: 'Kannada', flag: '🇮🇳' },
  { code: 'ko-KR', shortCode: 'KR', language: 'Korean', flag: '🇰🇷' },
  { code: 'ms-MY', shortCode: 'MY', language: 'Malay', flag: '🇲🇾' },
  { code: 'mr-IN', shortCode: 'MR-IN', language: 'Marathi', flag: '🇮🇳' },
  { code: 'no-NO', shortCode: 'NO', language: 'Norwegian', flag: '🇳🇴' },
  { code: 'pl-PL', shortCode: 'PL', language: 'Polish', flag: '🇵🇱' },
  { code: 'pt-BR', shortCode: 'BR', language: 'Portuguese', flag: '🇵🇹' },
  { code: 'ro-RO', shortCode: 'RO', language: 'Romanian', flag: '🇷🇴' },
  { code: 'ru-RU', shortCode: 'RU', language: 'Russian', flag: '🇷🇺' },
  { code: 'sv-SE', shortCode: 'SE', language: 'Swedish', flag: '🇸🇪' },
  { code: 'ta-IN', shortCode: 'TA-IN', language: 'Tamil', flag: '🇮🇳' },
  { code: 'te-IN', shortCode: 'TE-IN', language: 'Telugu', flag: '🇮🇳' },
  { code: 'th-TH', shortCode: 'TH', language: 'Thai', flag: '🇹🇭' },
  { code: 'tr-TR', shortCode: 'TR', language: 'Turkish', flag: '🇹🇷' },
  { code: 'vi-VN', shortCode: 'VN', language: 'Vietnamese', flag: '🇻🇳' },
  { code: 'ht-HT', shortCode: 'HT', language: 'Haitian Creole', flag: '🇭🇹' },
]);
